import { render, staticRenderFns } from "./MobileError.vue?vue&type=template&id=68732c3b&scoped=true"
import script from "./MobileError.vue?vue&type=script&lang=js"
export * from "./MobileError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68732c3b",
  null
  
)

export default component.exports